import { z } from 'zod';

/**
 * URL search params for the 849 marking inbox. Single source of truth: used
 * both as the route's `validateSearch` (routes.tsx) and as the inferred type
 * the page reads. (This route lives under the pathless authenticated parent, so
 * TanStack's typed `useSearch({ from })` doesn't resolve — the page reads via
 * `useSearch({ strict: false })` and asserts this schema's type, matching the
 * sibling Ship & Debit pages.)
 */
export const manual849SearchSchema = z.object({
  page: z.number().int().min(1).optional().catch(undefined),
  pageSize: z.number().int().min(1).max(100).optional().catch(undefined),
  from: z.string().optional(),
  to: z.string().optional(),
  subject: z.string().optional(),
  onlyWithoutResponse: z.boolean().optional(),
  hideInternalSenders: z.boolean().optional(),
  inboundEmailId: z.string().optional(),
});

export type Manual849Search = z.infer<typeof manual849SearchSchema>;
